/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import React from 'react';
import PropTypes from 'prop-types';

import {useQuery} from '@tanstack/react-query';

import {isServer} from '@salesforce/retail-react-app/app/utils/utils';

import {useService} from '@amblique/base/app/hooks';
import {SFCCService} from '@amblique/base/shared/services/sfcc-service';

export const ClientDataContext = React.createContext({
  contents: {},
  preferences: {},
  resources: {},
  urls: {},
});

/**
 * @param {{children: React.ReactNode}} args
 *
 * @returns {React.ReactNode}
 */
export function ClientDataProvider({children}) {
  const sfccService = useService(SFCCService);

  const clientData = useQuery({
    enabled: isServer && sfccService instanceof SFCCService,
    queryKey: [sfccService.key, 'Site', 'ClientData'],
    queryFn: () => sfccService.getClientData(),
  });

  return (
    <ClientDataContext.Provider value={clientData}>
      {children}
    </ClientDataContext.Provider>
  );
}

ClientDataProvider.displayName = 'ClientDataProvider';
ClientDataProvider.propTypes = {
  children: PropTypes.node,
};
